import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ManifestDocument from 'components/OperationCycle/ManifestDocument';

const ManifestDocumentScreen = () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <ManifestDocument />
      </SiteContent>
    </ContentLayout>
  );
};

export default ManifestDocumentScreen;
